<template>
  <Container
    v-if="title || people.length > 0"
    id="people"
    class="mb-10 md:mb-15 xl:mb-17.5! 2xl:mb-20!"
  >
    <div
      class="bp1440-w-740 bp1680-w-863 mx-auto flex w-full max-w-185 flex-col gap-3.75 md:w-151.25 lg:w-153.75 xl:w-[77%]"
    >
      <h2
        v-if="title"
        class="font-header bp1680-text-23 leading-[120%] text-black md:text-[17px] xl:text-xl"
      >
        {{ title }}
      </h2>

      <div v-if="people.length > 0" class="border-gray flex flex-col border-b">
        <PersonRow
          v-for="(person, index) in visiblePeopleInitial"
          :key="person.id"
          :person="person"
          :is-last="index === visiblePeopleInitial.length - 1 && !isExpanded"
        />

        <div
          v-if="visiblePeopleAnimated.length > 0"
          class="grid transition-all duration-400 ease-in-out"
          :class="
            isExpanded
              ? 'grid-rows-[1fr] opacity-100'
              : 'grid-rows-[0fr] opacity-0'
          "
        >
          <div class="flex flex-col overflow-hidden">
            <PersonRow
              v-for="(person, index) in visiblePeopleAnimated"
              :key="person.id"
              :person="person"
              :is-last="index === visiblePeopleAnimated.length - 1"
              class="first:border-t-0!"
            />
          </div>
        </div>
      </div>

      <ShowMoreButton
        v-if="people.length > 5"
        v-model:is-expanded="isExpanded"
        button-class="md:pt-3.75"
      />
    </div>
  </Container>
</template>

<script setup lang="ts">
import type { Person } from '~/types'

interface Props {
  title: string
  people: Person[]
}

const props = defineProps<Props>()

const isExpanded = ref(false)

const togglePeople = () => {
  isExpanded.value = !isExpanded.value
}

const visiblePeopleInitial = computed(() => {
  return props.people?.slice(0, 5)
})

const visiblePeopleAnimated = computed(() => {
  return props.people?.slice(5)
})
</script>
